module.exports = __webpack_public_path__ + "img/jackhammer.47a460ba.png";